var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'deviation-cell-high': _vm.deviation < 0,
    'deviation-cell-normal': _vm.deviation === 0,
    'deviation-cell-low': _vm.deviation > 0,
  },staticStyle:{"text-align":"center","padding":"3px"}},[_c('b',[_vm._v(_vm._s(_vm.deviation))])])}
var staticRenderFns = []

export { render, staticRenderFns }